"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBaseDialogContent = void 0;
var react_1 = require("react");
function useBaseDialogContent(_a) {
    var children = _a.children, setIsContentAtTop = _a.setIsContentAtTop, setIsContentAtBottom = _a.setIsContentAtBottom;
    var rootRef = (0, react_1.useRef)(null);
    var checkScrollState = (0, react_1.useCallback)(function () {
        var target = rootRef.current;
        if (target) {
            setIsContentAtTop === null || setIsContentAtTop === void 0 ? void 0 : setIsContentAtTop(target.scrollTop === 0);
            setIsContentAtBottom === null || setIsContentAtBottom === void 0 ? void 0 : setIsContentAtBottom(target.scrollTop >= target.scrollHeight - target.offsetHeight);
        }
    }, [setIsContentAtTop, setIsContentAtBottom]);
    (0, react_1.useEffect)(function () {
        checkScrollState(); // after initial render
        window.addEventListener('resize', checkScrollState);
        return function () { return window.removeEventListener('resize', checkScrollState); };
    }, [checkScrollState, children]);
    return { rootRef: rootRef, checkScrollState: checkScrollState };
}
exports.useBaseDialogContent = useBaseDialogContent;
